<template>
	<div :class="$style.subbar">
		<a-row class="mr-4"
			v-for="(breadcrumb, idx) in breadcrumbList"
			:key="idx"
		>
			<span v-if="breadcrumb.first !==true" class="ant-breadcrumb-separator" style="margin-right:2rem;">/</span>
			<span v-if="breadcrumb.link !== 'no'">
				<a
					@click="routeTo(idx)"
				>
				{{ breadcrumb.name }}
				</a>
			</span>
			<span v-else>
				<span
					style="color:#1b55e3;"
				>
				{{ breadcrumb.name }}
				</span>
			</span>
		</a-row>
		<div :class="$style.divider" class="mr-4 d-none d-xl-block" />
		<div :class="$style.amount" class="mr-3 ml-auto d-none d-sm-flex">
			<p :class="$style.amountText">
				Influencers
				<span :class="$style.amountValue"> {{ getAccountInfluencers }} </span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '80%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '70%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
			</div>
		</div>
		<div :class="$style.amount" class="d-none d-sm-flex">
			<p :class="$style.amountText">
				Business
				<span :class="$style.amountValue">{{ getAccountBusiness }}</span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '20%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '35%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '45%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '55%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '70%' }" />
			</div>
		</div>
	</div>
</template>
<script>
import { ACCOUNT as ACCOUNT_ACTION } from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	components: {},
	data: function() {
		return {
			breadcrumbList: [],
		}
	},
	created() {
		this.loadAccount().then(() => {
			this.loading = false
		})
	},
	mounted() {
		this.updateList()
	},
	computed: {
		...mapGetters(['getAccountInfluencers', 'getAccountBusiness']),
	},
	methods: {
		routeTo(to) {
			if (this.breadcrumbList[to].link) {
				this.$router.push(this.breadcrumbList[to].link)
			}
		},
		updateList (to) {
			this.breadcrumbList = this.$route.meta.breadcrumb
		},
		...mapActions({
			loadAccount: ACCOUNT_ACTION.TYPE_COUNT,
		}),
	},
	watch: {
		'$route' () {
			this.breadcrumbList = this.$route.meta.breadcrumb
		},
	},
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
